function scaleCalculator(availableWidth, availableHeight, currentWidth, currentHeight) {
    return Math.min(availableWidth / currentWidth, availableHeight / currentHeight);
}

export default scaleCalculator;
